import * as actionTypes from './types';
import axios from 'axios';

export const searchCollaborators = (email) => async (dispatch) => {
  if (email.length < 2) {
    dispatch(setSearchedCollaboratorsLoading(false));
    dispatch(setCollaborators([]));
    return;
  }

  try {
    dispatch(setSearchedCollaboratorsLoading(true));

    const userRes = await axios.get(`/api/collaborator/email/${email}`);

    const results = userRes.data.collaborators || [];

    dispatch(setSearchedCollaboratorsLoading(false));
    dispatch(setCollaborators(results));
  } catch (error) {
    dispatch(setSearchedCollaboratorsLoading(false));
    dispatch(setCollaborators([]));
    console.log('Search Collaborators Error: ', error);
  }
};

export const addingActiveCollab = (activeCollaborators) => async (dispatch) => {
  const results = activeCollaborators || [];
  console.log('results are '+results);
  dispatch(addActiveCollaborator(activeCollaborators));

}

export const setCollaborators = (collaborators) => ({
  type: actionTypes.SET_COLLABORATORS,
  collaborators: collaborators,
});

export const setSearchedCollaboratorsLoading = (isLoading) => ({
  type: actionTypes.SET_SEARCHED_COLLABORATOR_LOADING,
  isLoading: isLoading,
});

export const setIsCollaborator = (isCollaborator) => ({
  type: actionTypes.SET_IS_COLLABORATOR,
  isCollaborator: isCollaborator,
});

export const setCollaboratorJourneys = (collaboratorJourneyArray) => ({
  type: actionTypes.SET_COLLABORATOR_JOURNEYS,
  collaboratorJourneys: collaboratorJourneyArray,
});

export const addJourneyCollaborators = (
  searchedCollaborators,
  journeyId,
  pillOptions
) => {
  return (dispatch) => {
    axios
      .post('/api/collaborator', {
        collaborators: searchedCollaborators,
        journeyId: journeyId,
        pillOptions: pillOptions,
      })
      .then((result) => {})
      .catch((error) => {
        console.log(error);
      });
  };
};

export const deleteJourneyCollaborators = (journeyId) => {
  return (dispatch) => {
    axios
      .delete(`/api/collaborator/${journeyId}`)
      .then((result) => {})
      .catch((error) => {
        console.log(error);
      });
  };
};

export const addActiveCollaborator = (activeCollaborators) => ({
  type: actionTypes.ADD_ACTIVE_COLLABORATOR,
  activeCollaborators: activeCollaborators,
});

export const deleteActiveCollaborator = (email) => ({
  type: actionTypes.DELETE_ACTIVE_COLLABORATOR,
  email: email,
});

export const deleteCollaborator = (id) => ({
  type: actionTypes.DELETE_COLLABORATOR,
  id: id,
});
